const GetTextoSlug = (texto) => {
  
  texto = texto.toLowerCase().trim();
  texto = texto.split('á').join('a');
  texto = texto.split('é').join('e');
  texto = texto.split('í').join('i');
  texto = texto.split('ó').join('o');
  texto = texto.split('ú').join('u');
  texto = texto.split('ü').join('u');
  
  texto = texto.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, '_');
  
  
  // replace space with dash/hyphen
  texto = texto.replace(/__+/g, '_');
  
  
  if (texto[0] === '_') {
    texto = texto.substr(1);
  }
  
  if (texto[texto.length - 1] === '_') {
    texto = texto.substr(0, texto.length - 1);
  }
  
  return texto;
};

module.exports = GetTextoSlug;